import styled from 'styled-components';

export const ProfileContainer = styled.button`
  border: none;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: 0.4s ease-in-out all;
  padding: 4px 8px 4px 8px;
  gap: 10px;
  background-color: transparent;

  &:hover {
    background-color: #d0ebff;
  }
`;

export const Meta = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;

  .name {
    font-size: 14px;
    line-height: 140%;
    font-weight: 400;
    color: #495057;
  }
  .email {
    color: #868e96;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
  }
  .badge {
    padding: 3px 10px;
    border-radius: 4px;
    color: #0177fb;
    background-color: #0177fb1a;
    border: 1px solid #0177fb;
  }
`;

export const Name = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: end;
  gap: 5px;
`;
